export default __webpack_public_path__ + "ecd019341c0ca30d4c26bd9f6972ce5e.webp";